// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-btn__content {\n  white-space: normal !important;\n  flex: auto !important;\n  letter-spacing: 0em !important;\n}\n", ""]);
// Exports
module.exports = exports;
